import React from 'react';
import { useTranslation } from 'react-i18next';
import { parseMimesToExtensions } from '../../../dom/parseMimesToExtensions';
import { Icon } from '../../icons/Icon';
import styles from '../Dropzone.module.scss';

export const DropzoneBody = ({ accept, isSuccess, dragging }: Props) => {

    const { t } = useTranslation();

    if (dragging) {
        return (
            <>
                <div className={styles.heading}>
                    <Icon className={styles.icon} type='image-file-upload' />
                    {t('dropzone.drop_to_upload')}
                </div>
                <div className={styles.accept}>{formatFileTypes(accept)}</div>
            </>
        );
    }

    if (isSuccess) {
        return (
            <>
                <div className={styles.heading}>
                    <Icon className={styles.icon} type='alert-circle-check' />
                    {t('dropzone.ready')}
                </div>
                <div className={styles.accept}>{formatFileTypes(accept)}</div>
            </>
        );
    }

    return (
        <>
            <div className={styles.heading}>
                <Icon className={styles.icon} type='image-file-upload' />
                {t('dropzone.click_to_upload')}
            </div>
            <div className={styles.accept}>{formatFileTypes(accept)}</div>
        </>
    );
};

type Props = {
    isSuccess: boolean;
    dragging: boolean;
    accept: string;
};

const formatFileTypes = (accept: string) => parseMimesToExtensions(accept)
    .map(e => e.toUpperCase())
    .join(', ');